import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import Input from '@material-ui/core/Input';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import Button from '@material-ui/core/Button';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import PlacesAutocomplete from 'react-places-autocomplete';
import ListItemText from '@material-ui/core/ListItemText';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Tooltip from '@material-ui/core/Tooltip';
import Hidden from '@material-ui/core/Hidden';

import {
  days,
  timezones,
  languages,
  trainingOrderings,
  trainingAttendanceTypes,
} from '../../../shared/Mappings';

import {
  getTimezoneObjectByCode,
  currentTimeInTimezone,
  getTimezoneNameByCode,
} from '../../../shared/Helpers';

const drawerWidth = 420;
const drawerWidthMobile = 330;

const styles = theme => ({
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 18px',
    ...theme.mixins.toolbar,
  },
  drawerPaper: {
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
    width: drawerWidthMobile,
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
    },
    [theme.breakpoints.down('330')]: { // Catches extremely small screens (galaxy x fold)
      width: '100%',
    },
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 0,
  },
  listDivider: {
    marginBottom: theme.spacing(),
  },
  toolbarDivider: {
    // backgroundColor: 'rgba(0, 0, 0, 0.42)',
  },
  loadingSpinnerContainer: {
    display: 'flex',
    height: '100%',
    marginTop: theme.spacing(4),
    justifyContent: 'center',
  },
  formControl: {
    display: 'flex',
    marginBottom: theme.spacing(2),
  },
  dateFieldLeft: {
    marginRight: theme.spacing(),
  },
  dateFieldRight: {
    marginLeft: theme.spacing(),
  },
  dateGroup: {
    paddingTop: theme.spacing(),
  },
  form: {
    padding: theme.spacing(2),
  },
  buttonContainer: {
    paddingTop: theme.spacing(),
    textAlign: 'right',
    paddingRight: theme.spacing(2),
  },
  button: {
    marginRight: theme.spacing(),
    marginLeft: theme.spacing(),
  },
  query: {
    backgroundColor: 'white',
    paddingBottom: theme.spacing(),
  },
  inputAdornment: {
    paddingTop: theme.spacing(),
  },
  timezoneGroup: {
    // paddingLeft: theme.spacing(),
    // paddingRight: theme.spacing(),
  },
  timezoneButton: {
    paddingBottom: theme.spacing(),
  },
  selectedPageSize: {
    backgroundColor: theme.palette.primary.dark,
  },
  pageSizeFormControl: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
});


class ListSearchPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const {
      classes,
      open,
      handleDrawerClose,
      handleDrawerOpen,
      handleViewToggle,
      checked,
      handleResetSearch,
      currentDay,
      handleDayChange,
      timezone,
      handleTimezoneChange,
      handleMakeQuery,
      loading,
      attendanceType,
      handleAttendanceTypeChange,
      language,
      handleLanguageChange,
      showTimezoneField,
      handleShowTimezoneFieldChange,
      ordering,
      handleOrderChange,
      pageSize,
      handlePageSizeChange,
      handleDummyQuery,
      eventTypes,
      eventType,
      handleEventTypeChange,
      trainer,
      trainers,
      handleTrainerChange,
      startDate,
      handleStartDateChange,
      endDate,
      handleEndDateChange,
      sortByDisabled,
      meetsOnDayHidden,
      address,
      handleLocationChange,
      handleLocationSelect,
      queryHasChanged,
    } = this.props;

    const today = new Date().getDay();

    const drawer = (
      <React.Fragment>
        <div className={classes.toolbarIcon}>
          <Grid component="label" container alignItems="center" spacing={0}>
            <Grid item>
              <Typography>List View</Typography>
            </Grid>
            <Grid item>
              <Switch
                checked={checked}
                onChange={e => handleViewToggle(e)}
                value="checked"
                color="default"
              />
            </Grid>
            <Grid item>
              <Typography>Map View</Typography>
            </Grid>
          </Grid>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider className={classes.toolbarDivider} color="textPrimary" />
        <form onSubmit={handleDummyQuery}>
          <div className={classes.form}>
            {/* EVENT TYPE */}
            <FormControl fullWidth className={classes.formControl}>
              <FormLabel color="secondary" htmlFor="belt-level-native-helper">Training Type</FormLabel>
              <NativeSelect
                fullWidth
                value={eventType}
                onChange={e => handleEventTypeChange(e)}
                input={<Input name="belt level" id="belt-level-native-helper" style={{ marginTop: 8 }} />}
              >
                {eventTypes.map((e) => {
                  if (e.public) {
                    if (e.extra) {
                      return (<option key={e.id} value={e.id}>{e.level + ' - ' + e.extra}</option>);
                    }
                    return (<option key={e.id} value={e.id}>{e.level}</option>);
                  }
                  return null;
                })}
              </NativeSelect>
            </FormControl>
            {/* TRAINER */}
            <FormControl fullWidth className={classes.formControl}>
              <FormLabel color="secondary" htmlFor="trainer-native-helper">Trainer</FormLabel>
              <NativeSelect
                fullWidth
                value={trainer}
                onChange={e => handleTrainerChange(e)}
                input={<Input name="trainer" id="trainer-native-helper" style={{ marginTop: 8 }} />}
              >
                {trainers.map((t, i) => <option key={t.id} value={i}>{t.first_name + ' ' + t.last_name}</option>)}
              </NativeSelect>
            </FormControl>
            {/* ATTENDANCE RADIOS */}
            <FormControl fullWidth component="fieldset" className={classes.formControl}>
              <FormLabel color="secondary" component="legend">Online/In-Person</FormLabel>
              <RadioGroup row aria-label="attendance" name="attendance" value={attendanceType} onChange={handleAttendanceTypeChange}>
                {trainingAttendanceTypes.map(theAttendanceType => (<FormControlLabel key={theAttendanceType.code} value={theAttendanceType.code} control={<Radio color="secondary" />} label={theAttendanceType.name} />))}
              </RadioGroup>
            </FormControl>
            {/* SEARCH */}
            {attendanceType === 'inperson' && (
              <PlacesAutocomplete
                value={address}
                onChange={e => handleLocationChange(e)}
                onSelect={e => handleLocationSelect(e)}
              >
                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                  autocompleteloading,
                }) => (
                  <div>
                    <Input
                      {...getInputProps({
                        fullWidth: true,
                        placeholder: 'Search Address, City, State or Zip',
                        className: classes.locationSearchInput,
                        endAdornment: <InputAdornment position="end"><SearchIcon /></InputAdornment>,
                      })}
                    />
                    <List className={classes.autocompleteDropdownContainer}>
                      {autocompleteloading && <div key="loading">Loading...</div>}
                      {suggestions.map((suggestion) => {
                        const className = suggestion.active
                          ? classes.suggestionItemActive
                          : classes.suggestionItem;
                        return (
                          <ListItem
                            key={suggestion.placeId}
                            {...getSuggestionItemProps(suggestion, { className })}
                          >
                            <ListItemText key={suggestion.placeId}>{suggestion.description}</ListItemText>
                          </ListItem>
                        );
                      })}
                    </List>
                  </div>
                )}
              </PlacesAutocomplete>
            )}
            {/* STARTS BETWEEN DATES */}
            <FormControl fullWidth className={classes.formControl}>
              <FormLabel component="legend">Starts Between Dates</FormLabel>
              <FormGroup row className={classes.dateGroup}>
                <TextField
                  id="start date"
                  label="Range Start"
                  type="date"
                  value={startDate}
                  className={classes.dateFieldLeft}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={e => handleStartDateChange(e)}
                />
                <TextField
                  id="end date"
                  label="Range End"
                  type="date"
                  value={endDate}
                  className={classes.dateFieldRight}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={e => handleEndDateChange(e)}
                />
              </FormGroup>
            </FormControl>
            {/* DAY */}
            {!meetsOnDayHidden && (
              <FormControl fullWidth className={classes.formControl}>
                <FormLabel color="secondary" htmlFor="day-native-helper">Meets on Day</FormLabel>
                <NativeSelect
                  fullWidth
                  value={currentDay}
                  onChange={e => handleDayChange(e)}
                  input={<Input name="day" id="day-native-helper" style={{ marginTop: 8 }} />}
                >
                  {days.map((day, i) => <option key={day} value={i}>{(i === today) ? '(Today) ' + day : day}</option>)}
                </NativeSelect>
              </FormControl>
            )}
            {/* LANGUAGE */}
            <FormControl fullWidth className={classes.formControl}>
              <FormLabel color="secondary" htmlFor="class-type-native-helper">Language</FormLabel>
              <NativeSelect
                fullWidth
                value={language}
                onChange={e => handleLanguageChange(e)}
                input={<Input name="class type" id="class-type-native-helper" style={{ marginTop: 8 }} />}
              >
                {languages.map(theLanguage => <option key={theLanguage.code} value={theLanguage.code}>{theLanguage.name}</option>)}
              </NativeSelect>
            </FormControl>
            {/* TIMEZONE */}
            <div className={classes.timezoneGroup}>
              {showTimezoneField
                ? (
                  <Autocomplete
                    disableClearable
                    color="secondary"
                    value={getTimezoneObjectByCode(timezone)}
                    options={timezones}
                    getOptionLabel={option => option.name + ' (' + currentTimeInTimezone(option.code) + ')'}
                    getOptionDisabled={option => option.code === ''}
                    onChange={handleTimezoneChange}
                    renderInput={params => <TextField {...params} label="Timezone" helperText="Show class times for timezone" />}
                  />
                )
                : (
                  <Typography color="textSecondary" className={classes.timezoneButton}>
                    Your Timezone
                    <Button size="small" onClick={handleShowTimezoneFieldChange}>{getTimezoneNameByCode(timezone)}</Button>
                  </Typography>
                )
              }
            </div>
            {/* SORT */}
            {sortByDisabled
              ? (
                <Tooltip placement="top-start" title="In-Person filter and location are required">
                  <FormControl disabled={sortByDisabled} fullWidth component="fieldset" className={classes.formControl}>
                    <FormLabel color="secondary" component="legend">Sort By</FormLabel>
                    <RadioGroup row aria-label="attendance" name="attendance" value={ordering} onChange={handleOrderChange}>
                      {trainingOrderings.map(theOrdering => <FormControlLabel key={theOrdering.code} value={theOrdering.code} control={<Radio color="secondary" />} label={theOrdering.name} />)}
                    </RadioGroup>
                  </FormControl>
                </Tooltip>
              )
              : (
                <FormControl disabled={sortByDisabled} fullWidth component="fieldset" className={classes.formControl}>
                  <FormLabel color="secondary" component="legend">Sort By</FormLabel>
                  <RadioGroup row aria-label="attendance" name="attendance" value={ordering} onChange={handleOrderChange}>
                    {trainingOrderings.map(theOrdering => <FormControlLabel key={theOrdering.code} value={theOrdering.code} control={<Radio color="secondary" />} label={theOrdering.name} />)}
                  </RadioGroup>
                </FormControl>
              )
            }
            {/* PAGE SIZE */}
            <FormControl fullWidth className={classes.pageSizeFormControl}>
              <FormLabel color="secondary" htmlFor="class-type-native-helper">Show&nbsp;</FormLabel>
              <ButtonGroup variant="text" color="secondary" aria-label="text primary button group">
                <Button onClick={() => handlePageSizeChange('20')} className={pageSize === '20' ? classes.selectedPageSize : classes.pageSizeOption}>20</Button>
                <Button onClick={() => handlePageSizeChange('50')} className={pageSize === '50' ? classes.selectedPageSize : classes.pageSizeOption}>50</Button>
                {/*<Button onClick={() => handlePageSizeChange('100')} className={pageSize === '100' ? classes.selectedPageSize : classes.pageSizeOption}>100</Button>*/}
                {/*<Button onClick={() => handlePageSizeChange('all')} className={pageSize === 'all' ? classes.selectedPageSize : classes.pageSizeOption}>All</Button>*/}
              </ButtonGroup>
            </FormControl>
            <div className={classes.buttonContainer}>
              <Button className={classes.button} onClick={handleResetSearch}>Reset</Button>
              <Button className={classes.button} variant="contained" color="secondary" disabled={loading || !queryHasChanged} onClick={handleMakeQuery}>Search</Button>
            </div>
          </div>
        </form>
        <Divider className={classes.listDivider} />
      </React.Fragment>
    );

    return (
      <React.Fragment>
        <Hidden lgUp>
          <SwipeableDrawer
            classes={{
              paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose),
            }}
            variant="temporary"
            open={open}
            onOpen={handleDrawerOpen}
            onClose={handleDrawerClose}
          >
            {drawer}
          </SwipeableDrawer>
        </Hidden>
        <Hidden smDown>
          <Drawer
            classes={{
              paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose),
            }}
            variant="permanent"
            open={open}
          >
            {drawer}
          </Drawer>
        </Hidden>
      </React.Fragment>
    );
  }
}

ListSearchPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  handleViewToggle: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleDrawerClose: PropTypes.func.isRequired,
  handleDrawerOpen: PropTypes.func.isRequired,
  handleResetSearch: PropTypes.func.isRequired,
  currentDay: PropTypes.number.isRequired,
  handleDayChange: PropTypes.func.isRequired,
  timezone: PropTypes.string.isRequired,
  handleTimezoneChange: PropTypes.func.isRequired,
  handleMakeQuery: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  attendanceType: PropTypes.string.isRequired,
  handleAttendanceTypeChange: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  handleLanguageChange: PropTypes.func.isRequired,
  showTimezoneField: PropTypes.bool.isRequired,
  handleShowTimezoneFieldChange: PropTypes.func.isRequired,
  ordering: PropTypes.string.isRequired,
  handleOrderChange: PropTypes.func.isRequired,
  pageSize: PropTypes.string.isRequired,
  handlePageSizeChange: PropTypes.func.isRequired,
  handleDummyQuery: PropTypes.func.isRequired,
  eventTypes: PropTypes.array.isRequired,
  eventType: PropTypes.number.isRequired,
  handleEventTypeChange: PropTypes.func.isRequired,
  trainer: PropTypes.number.isRequired,
  trainers: PropTypes.array.isRequired,
  handleTrainerChange: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  handleStartDateChange: PropTypes.func.isRequired,
  endDate: PropTypes.string.isRequired,
  handleEndDateChange: PropTypes.func.isRequired,
  sortByDisabled: PropTypes.bool.isRequired,
  meetsOnDayHidden: PropTypes.bool.isRequired,
  address: PropTypes.string.isRequired,
  handleLocationChange: PropTypes.func.isRequired,
  handleLocationSelect: PropTypes.func.isRequired,
  queryHasChanged: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ListSearchPanel);
